<template>
	<div
		v-touch:tap="tapHandler"
		v-touch:swipe.left="swipeLeftHandler"
		v-touch:swipe.right="swipeRightHandler"
		@contextmenu.prevent="contextMenuHandler"
		@keyup.enter="tapHandler"
		tabindex="0"
		role="link"
	>

		<template v-if="data">

			<div class="row">
				<div class="col-md-9">
					{{ data.title }}
				</div>
				<div class="col-md-3" v-if="showContextMenu">
					<button
						class="btn btn-danger float-right"
						v-touch:tap.stop="deleteItem"
					>
						Delete
					</button>
				</div>
			</div>
			<div class="row">
				<div class="col-md-3">
					{{ $config.getProgrammeNameById(data.inputs.programme) }}
					<template v-if="('year' in data.inputs) && data.inputs.year">
						{{ $t('year') }}
						{{ data.inputs.year }}
					</template>
					<template v-if="('selected_student_firm' in data.inputs) && data.inputs.selected_student_firm">
						{{ $t('firm') }}
						{{ $config.getFirmNameById(data.inputs.selected_student_firm) }}
					</template>
					<template v-if="('selected_student_group' in data.inputs) && data.inputs.selected_student_group">
						{{ $t('group') }}
						{{ $config.getGroupNameById(data.inputs.selected_student_group) }}
					</template>
				</div>
				<div class="col-md-3">
					{{ $config.getSpecialtyNameById(data.inputs.specialty) }}
				</div>
				<div class="col-md-3">
					{{ this.$datetime.getLocaleStringFromTimeStamp(data.created) }}
				</div>
				<div class="col-md-3">
					{{ status }}
				</div>
			</div>

		</template>

		<template v-else>

			<div class="avatar float-left mr-4 mb-3 lg:mb-0 skeleton"></div>
			<div class="float-left">
				<div class="skeleton midnight h20 w200 mb-3"></div>
				<div>
					<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
					<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
					<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
					<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
				</div>
			</div>

		</template>

	</div>
</template>

<script>
export default {
	props: ['data', 'swipedLeftItem'],
	data() {
		return {
		};
	},
	mounted() {
	},
	created: function () {
	},
	destroyed: function () {
	},
	methods: {
		tapHandler(e) {
			// ignore for right clicks
			if (e.button && e.button == 2) {
				return false;
			}
			if(this.data) {
				this.$emit('selectItem', this.data);
			}
		},
		swipeLeftHandler() {
			this.$emit("swipeLeftItem", this.data);
		},
		swipeRightHandler() {
			this.$emit("swipeRightItem", this.data);
		},
		contextMenuHandler() {
			this.$emit("contextMenuItem", this.data);
		},
		deleteItem() {
			this.$cfetch(`${this.$settings.APIBaseURL}/savedreports/delete`, {
				data: {
					id: this.data.id,
				},
			})
				.then((json) => {
					if (json.status.toLowerCase() === "success") {
						this.$emit("removeItem", this.data);
					}
				})
				.catch((error) => {
					this.$log.error.call(this, error);
				});
		}
	},
	computed: {
		showContextMenu() {
			return (
				this.swipedLeftItem &&
				this.swipedLeftItem.id == this.data.id
			);
		},
		status(){
			if(this.data.status == 2 || this.data.status == 3){
				return this.$t('preparing');
			}
			return this.$t('ready');
		}
	}
};
</script>
